import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useGetUserTaxDocument = () => {
  const context = useAuthContext(
    'tax_documents:edit,tax_documents:read,tax_documents_log:read,users:read',
  );
  const client = useApolloClient();
  const getUserTaxDocument = useCallback(
    ({ ssn, email, id, isPreview }) =>
      client
        .query({
          query: Queries.GetUserTaxDocument,
          variables: { ssn, email, id },
          context,
          fetchPolicy: 'no-cache',
        })
        .then(response => {
          const taxDocument = response.data.getUser.taxDocumentById;
          return isPreview
            ? {
                url: taxDocument.url,
                withCredentials: false,
                httpHeaders: {
                  accept: 'application/pdf',
                },
              }
            : taxDocument.url;
        }),
    [context, client],
  );
  return getUserTaxDocument;
};

export default useGetUserTaxDocument;
